import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetDistrictDetailQuery,
  useUpdateDistrictMutation,
} from "store/services/LocationsApi/districtApi";
import DistrictForm from "./districtComponents/DistrictForm";

const DistrictEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  console.log(id);

  const breadcrumbs = [
    {
      title: "District",
      path: "/app/crm/district/list",
    },
    {
      title: "Edit District",
    },
  ];

  const {
    data: districtDetail,
    isLoading: loadingDistrictDetail,
    error,
  } = useGetDistrictDetailQuery(id);

  const [updateDistrict, { isLoading: updatingDistrict }] =
    useUpdateDistrictMutation();

  const handleDistrictUpdate = async (data) => {
    try {
      await updateDistrict({
        ...data,
        id: districtDetail?._id,
      }).unwrap();
      toast.success("District successfully updated!");
      navigate(`/app/crm/district/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update district!"
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      loading={loadingDistrictDetail || updatingDistrict}
    >
      <BreadcrumbLayout.Paper>
        <BreadcrumbLayout.Error error={error} />

        <DistrictForm
          districtDetail={districtDetail}
          isBusy={loadingDistrictDetail || updatingDistrict}
          onSubmit={handleDistrictUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DistrictEditScreen;
